import {
    fetchAssessmentChallengesFailure,
    fetchAssessmentChallengesRequest,
    fetchAssessmentChallengesSuccess,
} from '@actions/assessmentChallenges';
import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import { convertArrToObj } from 'lib/src/utils/generic';

import { AssessmentChallenge } from 'src/types/shared/Assessments';

interface AssessmentsState {
    isFetching: boolean;
    fetchError: string | null;
    assessmentChallenges: Record<number, AssessmentChallenge>;
}

const initialState: AssessmentsState = {
    isFetching: false,
    fetchError: null,
    assessmentChallenges: {},
};

export default createReducer(initialState, {
    [fetchAssessmentChallengesRequest.type]: handleFetchRequest,
    [fetchAssessmentChallengesFailure.type]: handleFetchFailure,
    [fetchAssessmentChallengesSuccess.type]: handleFetchAssessmentChallengesSuccess,
});

function handleFetchRequest(state: AssessmentsState) {
    state.isFetching = true;
    state.fetchError = null;
}

function handleFetchFailure(state: AssessmentsState, action: PayloadAction<string>) {
    state.fetchError = action.payload;
    state.isFetching = false;
}

function handleFetchAssessmentChallengesSuccess(
    state: AssessmentsState,
    action: PayloadAction<AssessmentChallenge[]>,
) {
    state.assessmentChallenges = convertArrToObj(action.payload);
    state.isFetching = false;
}
